/* MG product buy box: option cards, purchase tiers priced from selling plans, one-time switch, welcome kit,
   mix and match (one flavor per bag slot, box image built from bag photos or a pre-made kit photo), add to cart + MG cart drawer. */
(() => {
  if (customElements.get('mg-buybox')) return;

  const esc = (t) => String(t ?? '').replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' })[c]);

  customElements.define('mg-buybox', class extends HTMLElement {
    connectedCallback() {
      this.p = JSON.parse(this.querySelector('[data-product]').textContent);
      this.cfg = JSON.parse(this.querySelector('[data-cfg]').textContent);
      this.opts = [...this.querySelectorAll('[data-opt]')];
      this.tiers = [...this.querySelectorAll('[data-tier]')];
      this.btn = this.querySelector('[data-add]');
      this.modeBtn = this.querySelector('[data-mode]');
      this.sub = true;
      // Mix and match: slots hold one flavor per bag; cur is the slot the next flavor tap fills.
      this.mixEl = this.$('[data-mix]');
      this.fi = this.mixEl ? Number(this.mixEl.dataset.opt) : -1;
      this.slots = [];
      this.cur = 0;
      const gal = this.closest('.mgbb__grid')?.querySelector('.mgbb__gal');
      this.gal = gal;
      this.combo = gal?.querySelector('[data-combo]');
      this.addEventListener('click', (e) => this.mixClick(e));
      // The option that holds the tier value (e.g. Quantity = 1 Bag) is hidden; tiers always buy that value.
      this.ti = (this.p.options || []).findIndex((_, i) => this.p.variants.some((v) => v.options[i] === this.cfg.tierValue));
      this.addEventListener('change', () => this.render());
      this.btn.addEventListener('click', () => this.add());
      this.modeBtn?.addEventListener('click', () => { this.sub = !this.sub; this.render(); });
      if (!this.tiers.some((t) => t.querySelector('input').checked)) this.tiers[0]?.querySelector('input').click();
      this.render();
    }

    $(sel) { return this.querySelector(sel); }
    money(cents) {
      const amount = (cents / 100).toFixed(2);
      return String(this.cfg.money || '${{amount}}').replace(/\{\{\s*amount\s*\}\}/, amount).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    }
    sel() {
      const s = [];
      this.opts.forEach((f) => { s[Number(f.dataset.opt)] = f.querySelector('input:checked')?.value; });
      if (this.ti >= 0) s[this.ti] = this.cfg.tierValue;
      return s;
    }
    flavor() { return this.mixEl?.querySelector('input:checked')?.value; }
    // Variant for one bag: the current selection with the mix option set to that bag's flavor.
    vf(f) {
      const s = this.sel();
      if (this.fi >= 0 && f !== undefined) s[this.fi] = f;
      return this.find(s);
    }
    find(s) { return this.p.variants.find((v) => v.options.every((o, i) => s[i] === undefined || o === s[i])); }
    // Tier plan setting holds a plan ID or an exact plan name (names are shared across products whose plan IDs differ).
    plan(tier, v = this.variant) {
      const want = tier.dataset.plan;
      if (!want || !v) return;
      const names = Object.fromEntries((this.p.selling_plan_groups || []).flatMap((g) => g.selling_plans.map((sp) => [sp.id, sp.name])));
      return (v.selling_plan_allocations || []).find((a) => String(a.selling_plan_id) === want || names[a.selling_plan_id] === want);
    }
    tier() { return this.tiers.find((t) => t.querySelector('input').checked) || this.tiers[0]; }

    render() {
      const s = this.sel();
      this.opts.forEach((f) => f.querySelectorAll('input').forEach((r) => {
        const test = s.slice(); test[Number(f.dataset.opt)] = r.value;
        r.closest('label').classList.toggle('is-na', !this.find(test)?.available);
      }));
      const v = this.variant = this.find(s) || this.p.variants[0];
      // One-time mode: tiers that only differ by plan collapse into the first tier with that quantity.
      // ponytail: tier prices use the selected flavor's price for every bag (all flavors cost the same); the cart uses each bag's own variant.
      const seen = new Set();
      this.tiers.forEach((t) => {
        const q = Number(t.dataset.qty) || 1;
        t.hidden = !this.sub && seen.has(q);
        seen.add(q);
        const name = t.querySelector('[data-title]');
        name.textContent = this.sub ? name.dataset.title : name.dataset.otpTitle;
        if (t.hidden && t.querySelector('input').checked) this.tiers.find((x) => !x.hidden && Number(x.dataset.qty) === q).querySelector('input').checked = true;
        const plan = this.sub && this.plan(t);
        const now = (plan ? plan.price : v.price) * q;
        const was = plan ? v.price * q + (Number(t.dataset.wasAdd) || 0) : Math.max(v.price, v.compare_at_price || 0) * q;
        t.querySelector('[data-now]').textContent = this.money(now);
        t.querySelector('[data-was]').textContent = was > now ? this.money(was) : '';
        const badge = t.querySelector('[data-badge-el]');
        badge.hidden = !plan || !t.dataset.badge;
        badge.textContent = t.dataset.badge.replace('[save]', Math.round((1 - now / was) * 100));
        t.querySelectorAll('[data-sub-only]').forEach((li) => { li.hidden = !plan; });
        const serving = t.querySelector('[data-serving]');
        const n = Number(t.dataset.servings) || 0;
        serving.hidden = !n;
        if (n) serving.textContent = this.cfg.serving.replace('[price]', this.money(Math.round(now / n)));
      });
      if (this.modeBtn) {
        this.modeBtn.hidden = !this.tiers.some((t) => this.plan(t));
        this.modeBtn.textContent = this.sub ? this.cfg.otpLink : this.cfg.subLink;
      }
      const delivery = this.$('[data-delivery]');
      if (delivery) delivery.hidden = !(this.sub && this.tier() && this.plan(this.tier()));
      this.box();
      const ok = this.ok = this.slots.every((f) => this.vf(f)?.available);
      this.btn.disabled = !ok;
      this.btn.textContent = ok ? this.btn.dataset.label : this.cfg.soldOut;
    }

    // Resizes the slots to the tier's bag count (keeps picks, new slots copy the last one) and redraws the box panel and image.
    box() {
      const t = this.tier();
      const n = Number(t?.dataset.qty) || 1;
      if (!this.mixEl) this.slots = Array(n).fill(this.flavor());
      while (this.slots.length < n) this.slots.push(this.slots[this.slots.length - 1] ?? this.flavor());
      this.slots.length = n;
      this.cur = Math.min(this.cur, n - 1);
      const panel = this.$('[data-box]');
      if (panel) {
        panel.hidden = n < 2;
        const fill = (s, map) => Object.entries(map).reduce((x, [k, val]) => x.replaceAll(`[${k}]`, val), s || '');
        const f = this.slots[this.cur];
        const kinds = new Set(this.slots).size;
        const all = this.$('[data-all]');
        all.textContent = fill(this.cfg.allLink, { flavor: this.flavor() });
        all.hidden = this.slots.every((x) => x === this.flavor());
        const el = this.$('[data-slots]');
        el.style.setProperty('--n', n);
        el.innerHTML = this.slots.map((x, i) => `<button type="button" class="mgbb__slot${i === this.cur ? ' is-on' : ''}" data-slot="${i}" aria-pressed="${i === this.cur}">${this.bag(x, 'mgbb__thumb')}<span class="mgbb__slot-n">${esc(fill(this.cfg.slotName, { n: i + 1 }))}</span><span>${esc(x)}</span></button>`).join('');
        this.$('[data-box-note]').textContent = fill(this.cfg.slotLabel, { n: this.cur + 1, total: n, flavor: f }) + (kinds > 1 ? ' · ' + fill(this.cfg.mixedLabel, { count: kinds }) : '');
      }
      if (this.combo) {
        const kit = this.sub && this.plan(t) && t.dataset.kit === 'true' && this.cfg.kitBase;
        // Kit tiers show one pre-made photo per flavor combination: mg-kit-{bags}b-{codes}.webp in Shopify Files,
        // codes sorted, each code = the flavor's word initials (French Vanilla = fv).
        const code = (f) => String(f).split(/\s+/).map((w) => w[0]).join('').toLowerCase();
        this.combo.innerHTML = kit
          ? `<img class="mgbb__combo-kit" src="${esc(`${this.cfg.kitBase}mg-kit-${n}b-${this.slots.map(code).sort().join('-')}.webp`)}" alt="">`
          : `<div class="mgbb__combo-bags" style="--w: ${[44, 40, 29][n - 1] || 22}%">${this.slots.map((x) => this.bag(x)).join('')}</div>`;
        // A single bag stands in the benefits + iced coffee photo (mg-onetime-bg.webp); 2-3 bags keep the plain gradient row.
        this.combo.classList.toggle('is-solo', !kit && n === 1);
      }
      this.gallery(this.flavor());
    }

    // One bag picture: the flavor's bag photo, or a colored placeholder until the photo is added.
    bag(f, cls = '') {
      const b = (this.cfg.bags || {})[f] || {};
      return b.img ? `<img class="${cls}" src="${esc(b.img)}" alt="${esc(f)}" loading="lazy">`
        : `<span class="${cls || 'mgbb__bag-ph'}" style="--c: ${esc(b.color || '#6F4E37')}">${cls ? '' : esc(f)}</span>`;
    }

    // Gallery shows the flavor's own images, or the product media when the flavor has none.
    gallery(f) {
      if (!this.gal || f === this.galFlavor) return;
      const first = this.galFlavor === undefined;
      this.galFlavor = f;
      const slides = [...this.gal.querySelectorAll('[data-flavor]')];
      const key = slides.some((s) => s.dataset.flavor === f) ? f : '';
      slides.forEach((s) => { s.hidden = s.dataset.flavor !== key; });
      this.gal.build?.();
      if (!first) this.gal.track?.scrollTo({ left: 0 });
    }

    mixClick(e) {
      if (!this.mixEl) return;
      const slot = e.target.closest('[data-slot]');
      if (slot) {
        this.cur = Number(slot.dataset.slot);
        const r = [...this.mixEl.querySelectorAll('input')].find((x) => x.value === this.slots[this.cur]);
        if (r) r.checked = true;
      } else if (e.target.closest('[data-all]')) {
        this.slots.fill(this.flavor());
      } else if (e.target.matches('[data-mix] input')) {
        // Fill the active slot, then move to the next one (stays on the last slot).
        this.slots[this.cur] = e.target.value;
        if (this.cur < this.slots.length - 1) this.cur++;
      } else return;
      this.render();
      if (!e.target.matches('input')) this.gal?.track?.scrollTo({ left: 0 });
    }

    post(url, body) {
      return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
        .then(async (res) => { if (!res.ok) throw new Error((await res.json().catch(() => ({}))).description || this.cfg.error); return res; });
    }

    async add() {
      const t = this.tier();
      const plan = this.sub && this.plan(t);
      // One cart line per flavor: that flavor's variant, quantity = its bag count, same plan.
      const counts = new Map();
      this.slots.forEach((f) => counts.set(f, (counts.get(f) || 0) + 1));
      const items = [...counts].map(([f, q]) => {
        const v = this.vf(f);
        const pl = this.sub && this.plan(t, v);
        return { id: v.id, quantity: q, ...(pl && { selling_plan: pl.selling_plan_id }) };
      });
      // Welcome kit: free items added once with subscription tiers. Existing kit lines are cleared first so the cart never holds two.
      const kit = plan && t.dataset.kit === 'true' ? (this.cfg.kit || '').split(',').map((x) => x.trim().split(':')).filter(([id]) => Number(id)) : [];
      const err = this.$('[data-err]');
      err.hidden = true;
      this.btn.disabled = true;
      try {
        if (kit.length) {
          await this.post('/cart/update.js', { updates: Object.fromEntries(kit.map(([id]) => [id, 0])) });
          kit.forEach(([id, tag]) => items.push({ id: Number(id), quantity: 1, properties: { _welcome_kit: tag || 'kit' } }));
        }
        await this.post('/cart/add.js', { items });
        if (window.MGCart?.open) await window.MGCart.open().catch(() => { location.href = '/checkout'; });
        else location.href = '/checkout';
      } catch (e) {
        err.textContent = e.message || this.cfg.error;
        err.hidden = false;
      } finally {
        this.btn.disabled = !this.ok;
      }
    }
  });
})();
